document.addEventListener("DOMContentLoaded", function () {
    const buttons = document.querySelectorAll('[data-modal-id]');
    if (buttons.length === 0) return;

    buttons.forEach(button => {
        button.addEventListener("click", function (event) {
            event.preventDefault();

            const modalId = this.getAttribute("data-modal-id");
            const modal = document.getElementById(modalId);

            if (modal) modal.style.display = "block";

            // ✅ match sitewide overlay behavior
            const overlays = document.querySelectorAll(".proFormModalOverlay");
            overlays.forEach((o) => (o.style.display = "block"));

            // optional fallback if some templates still use an id overlay
            if (!overlays.length) {
                const modalOverlay = document.getElementById("modalOverlay");
                if (modalOverlay) modalOverlay.style.display = "block";
            }
        });
    });
});
